import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engine-dashboard',
  templateUrl: './engine-dashboard.component.html',
  styleUrls: ['./engine-dashboard.component.scss']
})
export class EngineDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
